module.exports = __webpack_public_path__ + "img/Menu-15.d48206ca.png";